const REVISE = 'react-template//REVISE'
const REVISE_SUCCESS = 'react-template//REVISE_SUCCESS'
const REVISE_FAIL = 'react-template//REVISE_FAIL'

const REQUEST_ASSESSMENT = 'react-template//REQUEST_ASSESSMENT'
const REQUEST_ASSESSMENT_SUCCESS = 'react-template//REQUEST_ASSESSMENT_SUCCESS'
const REQUEST_ASSESSMENT_FAIL = 'react-template//REQUEST_ASSESSMENT_FAIL'

const REMOVE_ASSESSMENTS = 'react-template//REMOVE_ASSESSMENTS'

const initialState = {
  loaded: false,
  requestAssessment: {},
  data: null
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case REVISE:
      return {
        ...state,
        loading: true
      }

    case REVISE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        data: action.result
      }

    case REVISE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case REQUEST_ASSESSMENT:
      return {
        ...state,
        loading: true
      }

    case REQUEST_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        requestAssessment: action.result
      }

    case REQUEST_ASSESSMENT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    case REMOVE_ASSESSMENTS:
      return initialState

    default:
      return state
  }
}

export function getActivitiesApproval(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/activities/${activityID}/approvals/${actionID}`)
  }
}

export function getActivitiesAssessment(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/activities/${activityID}/assessments/${actionID}`)
  }
}

export function getActivitiesSignOff(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/activities/${activityID}/sign-offs/${actionID}`)
  }
}

export function getRpApproval(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/residential-projects/${activityID}/approvals/${actionID}`)
  }
}

export function getRpAssessment(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/residential-projects/${activityID}/assessments/${actionID}`)
  }
}

export function getRpSignOff(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/residential-projects/${activityID}/sign-offs/${actionID}`)
  }
}

export function getAjApproval(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/aj-participant-events/${activityID}/approvals/${actionID}`)
  }
}

export function getAjAssessment(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/aj-participant-events/${activityID}/assessments/${actionID}`)
  }
}

export function getAjRequestAssessment(id, actionID) {
  return {
    types: [
      REQUEST_ASSESSMENT,
      REQUEST_ASSESSMENT_SUCCESS,
      REQUEST_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(`api/aj-participant-events/${id}/assessment-requests/${actionID}`)
  }
}

export function getActivityRequestAssessment(id, actionID) {
  return {
    types: [
      REQUEST_ASSESSMENT,
      REQUEST_ASSESSMENT_SUCCESS,
      REQUEST_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(`api/activities/${id}/assessment-requests/${actionID}`)
  }
}

export function getRpRequestAssessment(id, actionID) {
  return {
    types: [
      REQUEST_ASSESSMENT,
      REQUEST_ASSESSMENT_SUCCESS,
      REQUEST_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(`api/residential-projects/${id}/assessment-requests/${actionID}`)
  }
}

export function getAjSignOff(activityID, actionID) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(`api/aj-events/${activityID}/sign-offs/${actionID}`)
  }
}

// Preparation & Training
export function getPTSignOff(awardId, actionId) {
  return {
    types: [REVISE, REVISE_SUCCESS, REVISE_FAIL],
    promise: client =>
      client.get(
        `api/awards/${awardId}/aj-preparation-trainings/sign-offs/${actionId}`
      )
  }
}

export function removeAssessments() {
  return {
    type: REMOVE_ASSESSMENTS
  }
}
